import { t } from 'i18next'
import * as z from 'zod'

const MIN_LENGTH = {
  quantity: 0,
}
const MAX_LENGTH = {
  quantity: 999,
  note: 20,
}

export const schema = z.object({
  items: z.array(
    z.object({
      itemCode: z.string(),
      salesTypeQuantities: z.array(
        z.object({
          salesType: z.string().min(1),
          quantity: z
            .number({ invalid_type_error: t('item.validation.required') })
            .min(
              MIN_LENGTH.quantity,
              t('item.validation.min', { min: MIN_LENGTH.quantity })
            )
            .max(
              MAX_LENGTH.quantity,
              t('item.validation.max', { max: MAX_LENGTH.quantity })
            ),
          note: z
            .string()
            .max(
              MAX_LENGTH.note,
              t('item.validation.maxLength', { max: MAX_LENGTH.note })
            )
            .default(''),
        })
      ),
    })
  ),
})
